import { IsIncludes } from 'modules';

export const menuItemHasAccess = (menuItem, userPermissions, modularityPermissions) => {
  if (!menuItem.permission) return true;
  const pool = menuItem.modularity ? modularityPermissions : userPermissions;
  return IsIncludes(pool, menuItem.permission, menuItem?.isVisit, menuItem?.isDevider);
};

// A dropdown parent whose every sub-route failed the permission check is
// dropped too (P20M-1327): "data" has no permission of its own, so a GovRAMP-only
// Visitor would otherwise be left with an empty dropdown. Parents that start
// out with no sub-routes (help without dashboard links) are left untouched.
const allSubRoutesFiltered = (item, subRoutes) => item.subRoutes?.length > 0 && subRoutes.length === 0;

export const filterRoutesByPermissions = (routes, userPermissions, modularityPermissions) =>
  routes
    .map((item) => {
      const subRoutes = item.subRoutes
        ? item.subRoutes.filter((sub) => menuItemHasAccess(sub, userPermissions, modularityPermissions))
        : null;
      if (!menuItemHasAccess(item, userPermissions, modularityPermissions)) return null;
      if (allSubRoutesFiltered(item, subRoutes)) return null;
      return { ...item, subRoutes };
    })
    .filter(Boolean);
